const reportApi = {
  GET_REPORT: "/api/restaurant/reports/all",
};
export default reportApi;
